import moment from 'moment';
import { Word } from '@/domains/transcript';
import { DeleteType } from '@/domains/asset';

export const formatDuration = (totalSeconds: number): string => {
  if (!totalSeconds || totalSeconds <= 0) {
    return '00:00';
  }

  if (totalSeconds < 60) {
    return `${Math.ceil(totalSeconds)}s`;
  }
  if (totalSeconds < 3600) {
    return moment.utc(totalSeconds * 1000).format('mm:ss') + ' mins';
  }
  return moment.utc(totalSeconds * 1000).format('HH:mm:ss') + ' hrs';
};

// Utility function to calculate filler words count and duration
export const getFillerWordsInfo = (
  captions: Word[] | undefined
): { fillerWordsCount: number; fillerWordDuration: number } => {
  if (!captions || captions.length === 0) {
    return { fillerWordsCount: 0, fillerWordDuration: 0 };
  }

  let fillerWordsCount = 0;
  let fillerWordDuration = 0;

  for (const word of captions) {
    if (word.is_filler === true) {
      fillerWordsCount++;
      if (word.processed_start_time !== undefined && word.processed_end_time !== undefined) {
        fillerWordDuration += word.processed_end_time - word.processed_start_time;
      }
    }
  }

  return {
    fillerWordsCount,
    fillerWordDuration
  };
};

export function hasFillerWordsDeleted(deletes: Record<string, { deleteType?: DeleteType }> | undefined): boolean {
  if (!deletes) {
    return false;
  }
  return Object.values(deletes).some(del => del && del.deleteType === 'FILLER_WORDS_MENU');
}
